import React from "react";
import DashboardBarChart from "../../common/DashboardBarChart";

const FeatureBudgetAnalysis = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center h-[300px]">
        <div className="animate-spin h-8 w-8 border-b-2 border-teal-700 rounded-full"></div>
        <span className="ml-2">Loading feature budget analysis...</span>
      </div>
    );
  }

  // Top 10 features by total cost
  const items = [...(data?.budgetDistribution?.byFeature || [])]
    .sort((a, b) => (b.totalCost || 0) - (a.totalCost || 0))
    .slice(0, 10)
    .map((item) => ({
      name: item.featureName || "Unknown",
      count: item.totalCost || 0,
    }));

  return (
    <div className="bg-white p-2">
      <DashboardBarChart horizontal items={items} unit="budget" />
    </div>
  );
};

export default FeatureBudgetAnalysis;
